import { useEffect, useState } from "react";
import { APP_VERSION } from "../version"; 

export function useVersionCheck() {
  const [isOutdated, setIsOutdated] = useState(false);
  const [latestVersion, setLatestVersion] = useState(null);

  useEffect(() => {
    fetch("/version.json", { cache: "no-cache" })
      .then(res => res.json())
      .then(data => {
        setLatestVersion(data.version);
        if (data.version !== APP_VERSION) {
          setIsOutdated(true);
        }
      })
      .catch(err => console.error("Erro ao verificar versão", err));
  }, []);

  return { isOutdated, latestVersion };
}
